export default "__VITE_ASSET__BMcsJqyE__"